import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays the kit specification panel.
 * Its colour row reflects the selected variant, so the whole panel is morphed from the
 * section HTML the variant picker already fetched rather than patched field by field.
 */
class ProductKitDetails extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateKitDetails);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateKitDetails);
  }

  /**
   * Updates the kit details panel.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateKitDetails = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Matched on block id, so two panels in one section do not overwrite each other
    const newKitDetails = event.detail.data.html.querySelector(
      `product-kit-details-component[data-block-id="${this.dataset.blockId}"]`,
    );

    if (!newKitDetails) return;

    morph(this, newKitDetails, { childrenOnly: true });
  };
}

if (!customElements.get('product-kit-details-component')) {
  customElements.define('product-kit-details-component', ProductKitDetails);
}
